import { type PropsWithChildren, createContext } from 'react'
import { type Theme } from '@dhl-ui/theme'

export const defaultThemeContext = {}

export const ThemeContext = createContext<Theme>(defaultThemeContext as Theme)

/**
 * JIRA-#DS-53
 *
 * Its only purpose is to understand if consumers are using our ThemeProvider or not
 * so they are save to use our `useTheme` hook.
 *
 * We can simply remove this provider and just export useTheme directly from material ui when there is no old theme
 * left anymore. We then keep the useTheme export from this library so people will not consume Theme indirectly anymore.
 *
 * @important only exported for our connector, should not directly be used in any other usecase!
 */
export const UseThemeProvider = ({ children, theme }: PropsWithChildren<{ theme: Theme }>) => (
  <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
)
